<template>
  <div class="container">
    <!-- 修改配方状态 -->
    <Modal
      v-model="changeStatusModel"
      @on-ok="changeStatus"
      @on-cancel="cancel"
      title="修改配方状态"
    >
      <RadioGroup v-model="status">
        <Radio label="reviewing">
          <span>审核中</span>
        </Radio>
        <Radio label="verified">
          <span>通过</span>
        </Radio>
        <Radio label="rejected">
          <span>拒绝</span>
        </Radio>
        <Radio label="canceled">
          <span>弃用</span>
        </Radio>
      </RadioGroup>
    </Modal>
    <!-- 删除配方 -->
    <Modal v-model="deleteRecipModel" @on-ok="deleteRecipe">
      <p>你确定要删除这个配方吗？</p>
    </Modal>
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索客户..."
        @on-change="searchRecipe"
        clearable
        icon="ios-search"
        style="width: 250px; margin-right: 20px"
      >
      </Input>
      <div style="margin-right: auto">
        <RadioGroup
          class="view-switch"
          v-model="view"
          type="button"
          @on-change="changeView"
        >
          <Radio label="list"><Icon type="md-menu" /></Radio>
          <Radio label="card"><Icon type="ios-grid" /></Radio>
        </RadioGroup>
      </div>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadRecipe"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button
        v-if="currentUser.superAdmin"
        type="primary"
        @click="toMaterialSearchAndReplace"
        style="margin-right: 20px"
        >原材料搜查与替换</Button
      >
    </div>
    <div class="table-wrapper" v-if="view === 'list'" ref="tableWrapper">
      <Table :columns="columns" :data="tableData" :height="tableHeight">
      </Table>
    </div>
    <!-- 卡片模式 -->
    <div class="card-wrapper" v-if="view === 'card'">
      <div
        class="card-item"
        v-for="item in tableData"
        :value="item._id"
        :key="item._id"
      >
        <Card style="width: 320px">
          <div class="card-title">
            <h3 slot="title">{{ item.customer.name }}</h3>
            <Dropdown trigger="click" @on-click="clickActionDropDown">
              <Icon type="ios-more" style="cursor: pointer" size="24" />
              <DropdownMenu slot="list">
                <DropdownItem :name="`edit ${item._id}`">编辑配方</DropdownItem>
                <DropdownItem :name="`status ${item._id}`"
                  >修改状态</DropdownItem
                >
                <DropdownItem
                  style="color: #ed4014"
                  :name="`delete ${item._id}`"
                  >删除配方</DropdownItem
                >
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="item">
            <div>配方</div>
            <div>#{{ item.NoId }} {{ item.name }}</div>
          </div>
          <div class="item">
            <div>创建人</div>
            <div>{{ item.createdBy ? item.createdBy.name : "" }}</div>
          </div>
          <div class="item">
            <div>审核人</div>
            <div>{{ item.verifiedBy ? item.verifiedBy.name : "" }}</div>
          </div>
          <div class="item">
            <div>状态</div>
            <div>{{ cardStatusToText(item.status) }}</div>
          </div>
          <div class="item">
            <div>创建时间</div>
            <div>{{ formatDate(item.createdAt) }}</div>
          </div>
          <!-- <Table :columns="cardColumns" :data="item.detail" border> </Table> -->
          <Row class="item">
            <Col span="8" style="text-align: left">材料</Col>
            <Col span="4" class="table-title">原配方</Col>
            <Col span="3" class="table-title">变化</Col>
            <Col span="5" class="table-title">新配方</Col>
          </Row>
          <div
            class="recipe-row"
            v-for="x in item.allDetail ? item.allDetail : item.detail"
            :value="x.material._id"
            :key="x.material._id"
          >
            <RecipeRow
              :field="x.material.model ? x.material.model : x.material.name"
              :value="item"
              :detail="x"
            />
          </div>
          <div class="verify-recipe" v-if="item.status === 'reviewing'">
            <Button
              type="success"
              @click="verifiedRecipe({ id: item._id, status: 'verified' })"
              ghost
              >合格</Button
            >
            <Button
              type="error"
              @click="verifiedRecipe({ id: item._id, status: 'rejected' })"
              ghost
              >不合格</Button
            >
          </div>
        </Card>
      </div>
    </div>
    <RecipeDetailDrawer ref="RecipeDetailDrawer" />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import RecipeDetailDrawer from "./RecipeDetailDrawer";
import RecipeRow from "./RecipeRow.vue";
import _ from "lodash";

const statusToText = {
  created: "未接单",
  verified: "合格",
  reviewing: "待验收",
  rejected: "不合格",
  canceled: "已取消",
};
export default {
  name: "Recipe",
  components: {
    RecipeDetailDrawer,
    RecipeRow,
  },
  data() {
    return {
      page: 0,
      tableHeight: 300,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "配方",
          key: "recipe",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  cursor: "pointer",
                  color: "#42b983",
                },
                on: {
                  click: () => {
                    this.$refs.RecipeDetailDrawer.openDrawer(params.row);
                  },
                },
              },
              [h("div", params.row.name)]
            );
          },
        },
        {
          title: "销售简称",
          key: "sales",
          render: (h, params) => {
            return h(
              "div",

              [h("div", params.row.sales ? params.row.sales.abbr : "")]
            );
          },
        },
        {
          title: "客户",
          key: "customer",
          render: (h, params) => {
            return h("div", [h("div", params.row.customer.name)]);
          },
        },
        {
          title: "NoId",
          key: "NoId",
          align: "center",
          render: (h, params) => {
            return h("div", [h("div", "#" + params.row.NoId)]);
          },
        },

        {
          title: "创建人",
          key: "createdBy",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("div", params.row.createdBy ? params.row.createdBy.name : ""),
            ]);
          },
        },
        {
          title: "创建时间",
          key: "createdAt",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("div", dayjs(params.row.createdAt).format("YYYY-MM-DD HH:mm")),
            ]);
          },
        },
        {
          title: "状态",
          key: "status",
          align: "center",
          render: (h, params) => {
            return h("div", [h("div", statusToText[params.row.status])]);
          },
        },
      ],
      cardColumns: [
        {
          title: "材料",
          key: "material",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                params.row.material.model
                  ? params.row.material.model
                  : params.row.material.name
              ),
            ]);
          },
        },
        {
          title: "比例",
          key: "ratio",
          align: "right",
          render: (h, params) => {
            return h("div", [
              h("h4", (params.row.ratio * 100).toFixed(2) + "%"),
            ]);
          },
        },
      ],
      recipeSalesList: [],
      view: "list",
      changeStatusModel: false,
      deleteRecipModel: false,
      selectRecipe: null,
      status: null,
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.recipeSales.recipeSalesList,
      totalRows: (state) => state.recipeSales.totalCounts,
      currentUser: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    ...mapActions({
      getRecipeSales: "recipeSales/getRecipeSalesAction",
      updateRecipeSales: "recipeSales/updateRecipeSalesAction",
      deleteRecipeSales: "recipeSales/deleteRecipeSalesAction",
    }),
    searchRecipe: _.debounce(function () {
      this.page = 0;
      this.loadRecipe();
    }, 1000),
    async loadRecipe(page) {
      if (page) this.page = page - 1;
      let api = {
        skip: this.page * 15,
        limit: 15,
        with_detail: true,
      };
      if (this.searchText) api.cus_name = this.searchText;

      try {
        this.tableLoading = true;
        await this.getRecipeSales(api);

        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    unique(arr) {
      const res = new Map();
      return arr.filter(
        (x) => !res.has(x.material._id) && res.set(x.material._id, 1)
      );
    },
    async verifiedRecipe(verify) {
      const data = {};
      data.status = verify.status;
      const recipe = await this.updateRecipeSales({ id: verify.id, data });
      recipe.createdAt = dayjs(recipe.createdAt).format("YYYY-MM-DD HH:mm");
      this.currentRecipe = recipe;
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD HH:mm");
    },
    cardStatusToText(status) {
      return statusToText[status];
    },
    // 切换视图
    changeView(e) {
      this.$router.push({
        path: "/home/recipe",
        query: {
          view: e,
        },
      });
    },
    // 卡片模式对配方操作列表
    clickActionDropDown(name) {
      const actionCode = name.split(" ")[0];
      const id = name.split(" ")[1];
      const currentRecipe = this.tableData.find((x) => x._id === id);
      switch (actionCode) {
        case "status":
          this.changeStatusModel = true;
          this.selectRecipe = id;
          break;
        case "edit":
          this.open(currentRecipe);
          break;
        case "delete":
          this.deleteRecipe(currentRecipe);
          break;
      }
    },
    async changeStatus() {
      await this.updateRecipeSales({
        data: { status: this.status },
        id: this.selectRecipe,
      });
      this.status = null;
    },
    cancel() {},
    async open(currentRecipe) {
      await this.$refs.RecipeDetailDrawer.openDrawer(currentRecipe);
      this.$refs.RecipeDetailDrawer.EditRecipeDrawerOpened = true;
      this.$refs.RecipeDetailDrawer.editRecipe();
    },
    async deleteRecipe(currentRecipe) {
      try {
        await this.deleteRecipeSales({ id: currentRecipe._id });
        this.$Message.success(`删除成功`);
      } catch (error) {
        this.$Message.error(`删除失败: ${error}`);
      }
    },
    // 原材料搜查
    toMaterialSearchAndReplace() {
      this.$router.push({
        path: "/home/materialSearchAndReplace",
      });
    },
  },
  created() {
    this.loadRecipe();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    const view = this.$route.query.view;
    if (view) {
      this.view = view;
    }
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)

.container
  overflow-y auto

.card-wrapper
  display flex
  flex-wrap wrap

.card-item
  margin 0 20px 20px 0

.card-title
  border-bottom 1px solid #E2E5ED

.item, .card-title
  display flex
  justify-content space-between

.verify-recipe
  width 100%
  display flex
  justify-content space-around
  margin-top 20px

.table-title
  text-align right

.recipe-row:nth-child(even)
  background-color #f1f1f1
</style>